export default __webpack_public_path__ + "static/media/arrow_up.779326ab.svg";